<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Statystyki</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Statystyki</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight logs">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span class="ibox-toggle">
              <i :class="chevronFiltersClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isFiltersOpen">
            <div class="row">
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Wybierz daty</label>
                  <div class="col-sm-8">
                    <VueDatePicker
                      class="stats-daterangepicker"
                      v-model="statsRangeDate"
                      multi-calendars
                      :format="format"
                      range
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Sklep</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="shop"
                      mode="single"
                      placeholder="Sklep"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="shopOptions"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isStatsOpen = !isStatsOpen">
            <h5>Statystyki</h5>
            <span class="ibox-toggle">
              <i :class="chevronStatsClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isStatsOpen">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #item-login="item">
                    <router-link
                      :to="'/clients/' + item.pk"
                      class="col-sm-3 m-b-xs no-decoration"
                    >
                      {{ item.login }}
                    </router-link>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Podsumowanie</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div v-if="summary !== 0" class="col-sm-12 m-b-xs">
                <EasyDataTable
                  :headers="headers"
                  :items="summary"
                  border-cell
                  hide-footer="true"
                >
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="statsRangeDate1[0]" class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Filtry</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Wybierz daty</label>
                  <div class="col-sm-8">
                    <VueDatePicker
                      class="stats-daterangepicker"
                      v-model="statsRangeDate1"
                      multi-calendars
                      :format="format"
                      range
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Sklep</label>
                  <div class="col-sm-10">
                    <Multiselect
                      v-model="shop1"
                      mode="single"
                      placeholder="Sklep"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :options="shopOptions"
                    >
                    </Multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Statystyki</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items1">
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items1"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #item-login="item">
                    <router-link
                      :to="'/clients/' + item.pk"
                      class="col-sm-3 m-b-xs no-decoration"
                    >
                      {{ item.login }}
                    </router-link>
                  </template>
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Podsumowanie</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div v-if="summary1 !== 0" class="col-sm-12 m-b-xs">
                <EasyDataTable
                  :headers="headers"
                  :items="summary1"
                  border-cell
                  hide-footer="true"
                >
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="statsRangeDate" class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title"><h5>Porównaj zakres</h5></div>
          <div class="ibox-content">
            <div class="form-inline">
              <div class="form-group">
                <label for="no-comparative" class="sr-only">Liczba</label>
                <input
                  v-model="comparative"
                  type="number"
                  placeholder="Podaj liczbę"
                  min="1"
                  id="no-comparative"
                  class="form-control"
                />
              </div>
              <button @click="comparativeFn('week')" class="btn btn-white">
                Tygodni wcześniej
              </button>
              <button @click="comparativeFn('month')" class="btn btn-white">
                Miesięcy wcześniej
              </button>
              <button @click="comparativeFn('year')" class="btn btn-white">
                Lat wcześniej
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "OverallLogsList",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const clientStatsData = computed(() => store.getters.getClientStatsData);
    let headers = [
      { text: "Login", value: "login", sortable: true, search: true },
      {
        text: "Data rejestracji",
        value: "register_date",
        sortable: true,
      },
      { text: "Ostatne logowanie", value: "last_login", sortable: true },
      {
        text: 'Data ostatniego zamówienia "w realizacji"',
        value: "last_order",
        sortable: true,
      },
      { text: "Obrót netto", value: "netto", sortable: true },
      { text: "Ilość zamówień", value: "no_orders", sortable: true },
      {
        text: "Ilość zamówionych produktów",
        value: "no_ordered_products",
        sortable: true,
      },
      {
        text: "Średnia wartość zamówienia",
        value: "avg_order_value",
        sortable: true,
      },
      {
        text: "Średnia wartość produktu",
        value: "avg_product_value",
        sortable: true,
      },
      {
        text: "Subskrypcje",
        value: "no_subscriptions",
        sortable: true,
      },
      {
        text: "Ulubione produkty",
        value: "favorites",
        sortable: true,
      },
      {
        text: "Grupa rabatowa",
        value: "discount_group",
        sortable: true,
      },
      {
        text: "Facebook like",
        value: "fb_like",
        sortable: true,
      },
      {
        text: "Polecenia",
        value: "recommendation",
        sortable: true,
      },
      {
        text: "Znajomi",
        value: "fb_friends",
        sortable: true,
      },
    ];
    const shopOptions = computed(() => store.getters.getShopOptionsData);
    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronStatsClass = computed(() =>
      isStatsOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const shop = ref();
    const shop1 = ref();
    const isFiltersOpen = ref(true);
    const isStatsOpen = ref(true);
    const summary = ref([]);
    const summary1 = ref([]);
    const comparative = ref(0);
    const rowsPerPage = ref();
    const statsRangeDate = ref();
    const statsRangeDate1 = ref([]);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    let items = ref([]);
    let items1 = ref([]);
    let itemsAll = ref(0);
    let itemsAll1 = ref(0);
    const getClientStats = (comp = false) => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      let shopVal = shop.value;
      let date = statsRangeDate.value;
      if (comp) {
        date = statsRangeDate1.value;
        shopVal = shop1.value;
      }
      store.dispatch("getClientStats", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        date: date,
        search: searchValue.value,
        shop_version: shopVal,
        comp: comp,
      });
    };

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getClientStats();
          isSearch.value = false;
        }, 1000);
      }
    };

    const updateSort = () => {
      search.value = true;
    };

    const comparativeFn = (type) => {
      let dateStart = new Date(statsRangeDate.value[0]);
      let dateEnd = new Date(statsRangeDate.value[1]);
      dateStart.toLocaleDateString();
      dateEnd.toLocaleDateString();
      if (type === "week") {
        dateStart.setDate(dateStart.getDay() - comparative.value * 7);
        dateEnd.setDate(dateEnd.getDay() - comparative.value * 7);
      } else if (type === "month") {
        dateStart.setMonth(dateStart.getMonth() - comparative.value);
        dateEnd.setMonth(dateEnd.getMonth() - comparative.value);
      } else if (type === "year") {
        dateStart.setYear(dateStart.getFullYear() - comparative.value);
        dateEnd.setYear(dateEnd.getFullYear() - comparative.value);
      }
      statsRangeDate1.value[0] = dateStart;
      statsRangeDate1.value[1] = dateEnd;
      getClientStats(true);
    };

    const tableSummary = (comp = false) => {
      let tempSummary = {
        netto: 0,
        no_orders: 0,
        no_ordered_products: 0,
        no_subscriptions: 0,
        favorites: 0,
      };
      if (comp) {
        summary1.value = [];
        items1.value?.forEach((element) => {
          tempSummary.netto += element.netto;
          tempSummary.no_orders += element.no_orders;
          tempSummary.no_ordered_products += element.no_ordered_products;
          tempSummary.no_subscriptions += element.no_subscriptions;
          tempSummary.favorites += element.favorites;
        });
        tempSummary.netto = tempSummary.netto.toFixed(2);
        summary1.value.push(tempSummary);
      } else {
        summary.value = [];
        items.value?.forEach((element) => {
          tempSummary.netto += element.netto;
          tempSummary.no_orders += element.no_orders;
          tempSummary.no_ordered_products += element.no_ordered_products;
          tempSummary.no_subscriptions += element.no_subscriptions;
          tempSummary.favorites += element.favorites;
        });
        tempSummary.netto = tempSummary.netto.toFixed(2);
        summary.value.push(tempSummary);
      }
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getClientStats();
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("overallLSearchValue") !== null) {
        searchValue.value = localStorage.getItem("overallLSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getClientStats();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "overallLSearchValue",
          JSON.stringify(searchValue.value)
        );
        getClientStats();
      },
      { deep: true }
    );

    getClientStats();

    watch(
      () => clientStatsData.value,
      function (newValue) {
        if (newValue.comp) {
          itemsAll1.value = newValue.data.count;
          items1.value = [];
          newValue.data.results?.forEach((element) => {
            items1.value.push(element);
          });
          tableSummary(true);
        } else {
          itemsAll.value = newValue.data.count;
          items.value = [];
          newValue.data.results?.forEach((element) => {
            items.value.push(element);
          });
          tableSummary();
        }
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        getClientStats();
      }
    );
    watch(
      () => shop.value,
      function () {
        getClientStats();
      }
    );
    watch(
      () => shop1.value,
      function () {
        getClientStats(true);
      }
    );
    watch(
      () => statsRangeDate.value,
      function () {
        getClientStats();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getClientStats();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      serverOptions,
      items,
      items1,
      itemsAll,
      itemsAll1,
      loading,
      format,
      searchValue,
      search,
      updateSort,
      isSearch,
      rowsPerPage,
      statsRangeDate,
      statsRangeDate1,
      shop,
      shop1,
      shopOptions,
      summary,
      summary1,
      comparative,
      comparativeFn,
      selectPage,
      setRowsPerPage,
      resetFilters,
      isFiltersOpen,
      isStatsOpen,
      chevronFiltersClass,
      chevronStatsClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.ibox-toggle:hover {
  color: #333;
}
</style>
